import styled from "styled-components";

export const Flex = styled.div`
  display: flex;
  height: 11rem;
  max-height: 11rem;

  & > div {
    flex-grow: 1;

    &.header-horizontal {
      max-width: 24.9rem;
    }
  }

  .drawerHeader {
    max-width: 24.9rem;

    .avatar-header {
      flex-grow: 0;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #f3f3f3;
  align-items: center;
  padding: 0 2rem;
  max-height: 6.1rem;
  min-height: 6.1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  justify-content: space-between;

  div {
    flex-grow: 0 !important;
    display: flex;
    align-items: center;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Header/styles.js